import * as route from './route'
import * as httpHandle from './http'
// import * as locals from './locals'
import storeModule from './store'
// import EventHub from './eventHub'
// import './utils/iconfont.js'n


export {
  route,
  httpHandle,
  storeModule
}



// WEBPACK FOOTER //
// ./src/index.js